import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../../store/saasbomSlice";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetServicesQuery } from "../../services/saasbom.api";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import { getQueryStatus } from "../../utils";
import XbomExportActions from "../common/XbomExportActions/XbomExportActions";
import Filter from "./Filter/Filter";
import ServiceDetails from "./ServiceDetails/ServiceDetails";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "provider",
        label: "Provider",
        sortProperty: "provider",
        sortId: "saasbom-sort-provider",
        width: "30%",
    },
    {
        id: "name",
        label: "Name and version",
        sortProperty: "name",
        sortId: "saasbom-sort-name",
        width: "70%",
    },
    {
        id: "type",
        label: "Service type",
        sortProperty: "type",
        sortId: "saasbom-sort-type",
        width: "175px",
    },
    {
        id: "flow",
        label: "Service flow",
        sortProperty: "flow",
        sortId: "saasbom-sort-flow",
        width: "150px",
    },
    { id: "requires_auth", label: "Requires auth", width: "150px" },
    {
        id: "endpoint_count",
        label: "# Endpoints",
        sortProperty: "endpoint_count",
        sortId: "saasbom-sort-endpoint-count",
        startReverse: true,
        width: "150px",
    },
];
const SaaSBOMContent = () => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId, diffId } = useContext(ReportContext);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { match_count: 0, services: [] }, isLoading, isFetching, isError, error, } = useGetServicesQuery({
        ui_id: reportId,
        filter,
        sort,
        pagination,
    });
    const handleSortChange = (newSort) => {
        dispatch(sortUpdated(newSort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "SaaS bill of materials", details: [
                `${((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.xbom.saasbom) !== null && _a !== void 0 ? _a : 0).toLocaleString()} Services`,
            ], actions: React.createElement(XbomExportActions, null) }),
        React.createElement(Page.Filters, { found: {
                id: "saasbom-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "services",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "saasbom-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.services.map((service, index) => (React.createElement(ServiceDetails, { key: service.id, rowIndex: index, service: service })))))));
};
const SaaSBOM = () => {
    return (React.createElement(ErrorBoundary, { key: "saasbom" },
        React.createElement(SaaSBOMContent, null)));
};
export default SaaSBOM;
//# sourceMappingURL=SaaSBOM.js.map